"use strict";

exports.__esModule = true;
exports.IFrameWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _EditableIFrameElement = require("./EditableIFrameElement");
var _IFrameElement = require("./IFrameElement");
var _IFrameFields = require("./IFrameFields");
var _IFrameHeader = require("./IFrameHeader");
var _IFrameThumbnail = require("./IFrameThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var IFrameWidget = exports.IFrameWidget = {
  name: "IFrame",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "IFrameWidget.label",
    defaultMessage: "IFrame"
  }),
  icon: "label",
  group: _widgetGroups.OTHER_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "IFrame",
      props: Object.assign({
        width: 256,
        height: 256,
        flex: 1,
        urlTemplate: "https://example.com/"
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: [],
  requiresProps: ["x", "y", "width", "height", "urlTemplate"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 3840
    },
    height: {
      "default": 256,
      min: 32,
      max: 2160
    }
  },
  components: {
    Header: _IFrameHeader.IFrameHeader,
    Element: _IFrameElement.IFrameElement,
    Fields: _IFrameFields.IFrameFields,
    Thumbnail: _IFrameThumbnail.IFrameThumbnail,
    Editable: _EditableIFrameElement.EditableIFrameElement
  }
};